export default "  <img [src]=\"data.src\" />\r\n"